import {charcoal} from '../../sass/v2/_exports.sass';

export const GiftboxIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.6667 9.33333H25.0547C25.2502 8.68505 25.3442 8.01039 25.3333 7.33333C25.3333 4.76 23.24 2.66667 20.6667 2.66667C18.504 2.66667 17.06 4.64267 16.128 6.78C15.2093 4.76 13.692 2.66667 11.3333 2.66667C8.76 2.66667 6.66666 4.76 6.66666 7.33333C6.66666 8.128 6.772 8.78533 6.94533 9.33333H5.33333C3.86266 9.33333 2.66666 10.5293 2.66666 12V14.6667C2.66666 16.1373 3.86266 17.3333 5.33333 17.3333V26.6667C5.33333 28.1373 6.52933 29.3333 8 29.3333H24C25.4707 29.3333 26.6667 28.1373 26.6667 26.6667V17.3333C28.1373 17.3333 29.3333 16.1373 29.3333 14.6667V12C29.3333 10.5293 28.1373 9.33333 26.6667 9.33333ZM20.6667 5.33333C21.7693 5.33333 22.6667 6.23067 22.6667 7.33333C22.6667 9.33333 21.832 9.33333 21.3333 9.33333H18.0293C18.7107 7.232 19.7 5.33333 20.6667 5.33333ZM9.33333 7.33333C9.33333 6.23067 10.2307 5.33333 11.3333 5.33333C12.5173 5.33333 13.6187 7.36667 14.264 9.33333H10.6667C10.168 9.33333 9.33333 9.33333 9.33333 7.33333ZM5.33333 12H14.6667V14.6667H5.33333V12ZM8 26.6667V17.3333H14.6667V26.6667H8ZM24 26.6667H17.3333V17.3333H24V26.6667ZM17.3333 14.6667V12.1133L17.356 12H26.6667L26.668 14.6667H17.3333Z"
        fill={color}
      />
    </svg>
  );
};
